<div id="emoji-picker">
    <div class="card">
        <div class="tab clearfix">
            <ng-container *ngFor="let headerItem of header; let i = index;">
                <button class="tablinks" [class.active]="i == 0" [attr.data-id]="headerItem.target" (click)="openTab(headerItem.target)">{{ headerItem.emoji }}</button>
            </ng-container>    
        </div>
        <ng-container *ngFor="let headerItem of header; let i = index;">
            <div [id]="headerItem.target" class="tabcontent" [ngStyle]="{display: (i == 0) ? 'block' : ''}">
                <div *ngIf="i == 0" class="row">
                    <div class="col-12"><p class="emoji-title">Smileys & Emotion</p></div>
                    <div class="col-auto emoji-label" *ngFor="let item of smileys_and_emotion" (click)="clickEmoji(item.emoji)">{{ item.emoji }}</div>
                </div>
                <div *ngIf="i == 1" class="row">
                    <div class="col-12"><p class="emoji-title">People & Body</p></div>
                    <div class="col-auto emoji-label" *ngFor="let item of people_and_body" (click)="clickEmoji(item.emoji)">{{ item.emoji }}</div>
                </div>
                <div *ngIf="i == 2" class="row">
                    <div class="row">
                        <div class="col-12"><p class="emoji-title">Animals & Nature</p></div>
                        <div class="col-auto emoji-label" *ngFor="let item of animals_and_nature" (click)="clickEmoji(item.emoji)">{{ item.emoji }}</div>
                    </div>
                </div>
                <div *ngIf="i == 3" class="row">
                    <div class="col-12"><p class="emoji-title">Food & Drink</p></div>
                    <div class="col-auto emoji-label" *ngFor="let item of food_and_drink" (click)="clickEmoji(item.emoji)">{{ item.emoji }}</div>
                </div>
                <div *ngIf="i == 4" class="row">
                    <div class="col-12"><p class="emoji-title">Travel & Places</p></div>
                    <div class="col-auto emoji-label" *ngFor="let item of travel_and_places" (click)="clickEmoji(item.emoji)">{{ item.emoji }}</div>
                </div>
                <div *ngIf="i == 5" class="row">
                    <div class="col-12"><p class="emoji-title">Activities</p></div>
                    <div class="col-auto emoji-label" *ngFor="let item of activities" (click)="clickEmoji(item.emoji)">{{ item.emoji }}</div>
                </div>
                <div *ngIf="i == 6" class="row">
                    <div class="col-12"><p class="emoji-title">Objects</p></div>
                    <div class="col-auto emoji-label" *ngFor="let item of objects" (click)="clickEmoji(item.emoji)">{{ item.emoji }}</div>
                </div>
                <div *ngIf="i == 7" class="row">
                    <div class="col-12"><p class="emoji-title">Symbols</p></div>
                    <div class="col-auto emoji-label" *ngFor="let item of symbols" (click)="clickEmoji(item.emoji)">{{ item.emoji }}</div>
                </div>
                <div *ngIf="i == 8" class="row">
                    <div class="col-12"><p class="emoji-title">Flags</p></div>
                    <div class="col-auto emoji-label" *ngFor="let item of flags" (click)="clickEmoji(item.emoji)">{{ item.emoji }}</div>
                </div> 
            </div>
        </ng-container>
    </div>
</div>    